import { error, ok } from './result.js';
export const safeParse = (json, schema) => {
    try {
        const raw = JSON.parse(json);
        const res = schema.safeParse(raw);
        if (!res.success) {
            return error(res.error);
        }
        return ok(res.data);
    }
    catch (err) {
        return error(err);
    }
};
export const safeStringify = (data) => {
    try {
        return ok(JSON.stringify(data));
    }
    catch (err) {
        return error(err);
    }
};
//# sourceMappingURL=json.js.map